import React, { useEffect } from 'react';
import { useState } from 'react';
import { ReactComponent as MoreIcon } from './../../../assets/icons/more.svg';
import { ContextMenu } from './contextMenu';
import styles from './more.module.css';

export const More = ({actions}) => {

    const [show, setShow] = useState(false);
    const [pos, setPos] = useState({x: 0, y: 0});

    return <div className={styles.More}>
        <div className={styles.Icon + ' icon'} onClick={(e) => {
            setPos({x: e.clientX, y: e.clientY});
            setShow(!show);
        }}>
            <MoreIcon />
        </div>
        <ContextMenu actions={actions} x={pos.x} y={pos.y} show={show} onClose={() => setShow(false)} />
    </div>
}